import { render, staticRenderFns } from "./settlement-list.vue?vue&type=template&id=4fac3c68&"
import script from "./settlement-list.vue?vue&type=script&lang=js&"
export * from "./settlement-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports